<template>
  <div v-if="show">
    <weex-text class="item-bold-heading">Select an option</weex-text>
    <wxc-radio
      class="margin-left-20 margin-right-20"
      :list="cancelledChequeOptionsAsTitleAndValue()"
      :config="radioButtonConfig"
      :radio-button-on-right="false"
      @wxcRadioListChecked="onCollectionOptionSelected"
      ></wxc-radio>

    <wxc-button
      text="Continue"
      class="button_horizontal_center margin_top_20"
      type="blue"
      @wxcButtonClicked="onContinueClicked"
      ></wxc-button>
  </div>

</template>

<script>

  import AlertService from "../core/alert/AlertService";
  import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import WxcRadio from "../../../weex-ui/packages/wxc-radio/index";
  import { MessageConstants } from "../../utils/MessageConstantUtil";

  const SELECTED_OPTION_NOT_SUPPORTED = "Selected option is not supported.";
  const SELECT_OPTION_TO_CONTINUE = "Please select an option to continue.";

  const CANCELLED_CHEQUE_VALUE = "CANCELLED_CHEQUE";
  const CANCELLED_CHEQUE = "Cancelled Cheque";
  const BANK_STATEMENT_VALUE = "BANK_STATEMENT";
  const BANK_STATEMENT = "Bank Statement";
  const NONE_OF_THESE_VALUE = "NONE_OF_THESE";
  const NONE_OF_THESE = "None of these";

  export default {
    name: "CancelledChequeOptionsItem",
    components: { WxcButton, WxcRadio },
    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      cancelledChequeOptions: {
        type: Array,
        required: true,
        default: () => []
      },
    },

    data: () => ({
      selectedCollectionOption: "",
    }),

    methods: {
      showToast(message) {
        AlertService.showToast(message);
      },

      onCollectionOptionSelected(e) {
        this.selectedCollectionOption = e.value;
      },

      onContinueClicked() {
        if (this.selectedCollectionOption) {
          if (this.selectedCollectionOption === CANCELLED_CHEQUE_VALUE) {
            this.$emit("onUploadCancelledChequeSelected")
          } else if (this.selectedCollectionOption === BANK_STATEMENT_VALUE) {
            this.$emit("onUploadBankStatementSelected")
          } else if (this.selectedCollectionOption === NONE_OF_THESE_VALUE) {
            this.$emit("onNoneOfTheseSelected")
          } else {
            this.showToast(SELECTED_OPTION_NOT_SUPPORTED);
          }
        } else {
          this.showToast(SELECT_OPTION_TO_CONTINUE);
        }
      },

      cancelledChequeOptionsAsTitleAndValue() {
        const options = [];
        this.cancelledChequeOptions && this.cancelledChequeOptions.forEach(collectionOption => {
          if (collectionOption) {
            const optionToInsert = { title: collectionOption, value: collectionOption };
            if (collectionOption.includes(CANCELLED_CHEQUE)) {
              optionToInsert.value = CANCELLED_CHEQUE_VALUE;
              optionToInsert.checked = !this.selectedCollectionOption
                || this.selectedCollectionOption === CANCELLED_CHEQUE_VALUE;

              this.selectedCollectionOption = optionToInsert.checked
                ? CANCELLED_CHEQUE_VALUE
                : this.selectedCollectionOption;
            }
            if (collectionOption.includes(BANK_STATEMENT)) {
              optionToInsert.value = BANK_STATEMENT_VALUE;
              optionToInsert.checked = this.selectedCollectionOption === BANK_STATEMENT_VALUE;
            }
            if (collectionOption.includes(NONE_OF_THESE)) {
              optionToInsert.value = NONE_OF_THESE_VALUE;
              optionToInsert.checked = this.selectedCollectionOption === NONE_OF_THESE_VALUE;
            }
            options.push(optionToInsert);
          }
        });
        return options;
      }
    },

    computed: {
      radioButtonConfig() {
        return DefaultResourceConfig.RADIO_BUTTON;
      }
    }
  }
</script>

<style scoped></style>

<style
  scoped
  src="../../assets/style/base.css"></style>
